class ShopDeviceService extends BaseService
	@register()
	@inject 'PusherService'

	initializeDevices: (shopId, @registers) ->
		@devices = []
		@filter =
			register_id: null
			device_id: null
			registers: []
			devices: []

		@PusherService.subscribeToPresence shopId, @onSubscription.bind(@)

	isVisible: (device) ->
		return (!@filter.register_id? || @filter.register_id == device.register_id) &&
			(!@filter.device_id? || @filter.device_id == device.device_id)

	onSubscription: (channel) ->
		@devices = []

		for register in @registers
			if register.device_id?
				@devices.push({
					register_id: register.id
					register_name: register.name
					device_id: register.device_id
					is_online: false
				})

		for id, member of channel.members.members
			if member.device_id == channel.members.me.id
				continue

			# Assume one register can have only one device
			existingMember = _.find(@devices, (device) => device.register_id == member.register_id)

			if existingMember?
				existingMember.device_id = member.device_id
				existingMember.is_online = true
			else
				member.is_online = true
				member.is_global = false

				@devices.push(member)

		@concatDeviceList()

	concatDeviceList: ->
		@filter.registers = {}
		@filter.devices = {}

		for device in @devices
			if device.device_id?
				@filter.devices[device.device_id] ?= {
					id: device.device_id
					name: device.device_id
				}

			if device.register_id?
				@filter.registers[device.register_id] ?= {
					id: device.register_id
					name: device.register_name
				}

		@filter.devices = _.values(@filter.devices)
		@filter.registers = _.values(@filter.registers)
